import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardOverview, AdminDashboardSectionState } from "@/types/dashboard";

export type DashboardOverviewState = AdminDashboardSectionState<AdminDashboardOverview>;

export const dashboardOverviewInitialState: DashboardOverviewState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardOverview",
  initialState: dashboardOverviewInitialState,
  reducers: {
    setDashboardOverviewAction(state, { payload }: PayloadAction<AdminDashboardOverview | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardOverviewErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardOverviewAction, setDashboardOverviewErrorAction } = slice.actions;
export default slice.reducer;
